/**
 * Builds the range-selection model for replay mode: the spans of top-level,
 * non-trigger steps over the timeline's execution indices. Range boundaries snap to
 * whole top-level actions, so a range that touches a loop always covers the loop's
 * entire body — nested executions sit inside their parent's span.
 */
const getReplayRangeModel = ({ allSteps, timeMachine, steps }) => {
  const maxIndex = Math.max((timeMachine?.length || 1) - 1, 0);
  const rangeSteps = (allSteps || []).filter((entry) => {
    const step = steps?.find((n) => n.id === entry.stepId);
    return entry.indent === 0 && !!step && step.type !== 'trigger' && typeof entry.firstTime === 'number';
  });

  const spans = rangeSteps.map((entry, i) => ({
    stepId: entry.stepId,
    start: entry.firstTime,
    end: i + 1 < rangeSteps.length ? rangeSteps[i + 1].firstTime - 1 : maxIndex
  }));

  return {
    spans,
    min: spans[0]?.start,
    max: spans[spans.length - 1]?.end
  };
};

export const findSpanContaining = (spans = [], index) => {
  if (!spans.length) {
    return undefined;
  }
  return spans.find((span) => index >= span.start && index <= span.end) || (index < spans[0].start ? spans[0] : spans[spans.length - 1]);
};

export default getReplayRangeModel;
